import { render, staticRenderFns } from "./GrossSalaryDeductionForPersonalExpensesCalculation.vue?vue&type=template&id=0259c6d0"
import script from "./GrossSalaryDeductionForPersonalExpensesCalculation.vue?vue&type=script&lang=js"
export * from "./GrossSalaryDeductionForPersonalExpensesCalculation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports